import "font-awesome/css/font-awesome.min.css";
import React, { Component } from "react";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import NPS from "./ComponentV6/NPS";
import NPSV2 from "./ComponentV6/NPSV2";
import QuestionHeader from "../Component/QuestionHeader";

import LogoAssessmentHeader from "../Component/LogoAssessmentHeader";
import FeedbackModal from "./FeedbackModal";


class Survey extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {

  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.questions.submitfail) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: false,

        alreadySubmitted: true,
      };
    }
    if (nextProps.questions.answerSubmitSuccess) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: true,
        instructionPage: false,
      };
    } else {
      return {
        ...nextProps,
      };
    }
  }






  render() {

    let {
      EditButtonFn,
      check,
      onLogout,
      surveyScreenData,
      getAssessmenrEmployeeDetailsData,
      handleReport,
      surveyLanguageName,
      handleLanguage,
      LanguageList,
      surveyStatus,
      showWelcomeScreen,
      questionsList,
      themeType,
      getTheme,
      SurveyAttributes,
      surveyLanguageCode,
      functionNameVariable,
      welcomeTextDislay,
      goToInstructionPage,
      instructionPage,
      LabelObj,
      instructionTextDislay,
      goToQuestionPage,
      afterSubmitData,
      showQuestionScreen,
      submitSucces,
      getSecondsToTime,
      completedMilestone,
      CurrQuesIndex,
      changeType,
      answersList,
      showFeedbackModal,
      closeFeedbackModal,
      handleFeedbackInput,
      submitFeedback,
      clicked,
      isMobile,
      ansNPSInput,
      nextQues,
      unattemptList,
      showRedFlag,
      ShowSubmitButton,
      submitMandatory,
      submitBlock,
      saveAnswers,
      showThankyouScreen,
      showViewReportThankYouButton,
      alreadySubmitted,

      bgType, bgColor, timeCounter, getGroupIndex, hexToRgbA,
      bgImage,



    } = this.props;

    return (
      <>

        <div
          className="h-screen bg-cover bg-center w-full overflow-hidden"
          style={{
            backgroundImage: "url('https://plusinsight.happyplus.in/images//tp_survey-light-bg.webp')",

            // getTheme("backgroundImage",'url("/img/survey-bg.jpg")')
          }}
        >

          <LogoAssessmentHeader
            logout={onLogout}
            surveyScreenData={surveyScreenData}
            template={"v4"}
            details={getAssessmenrEmployeeDetailsData}
            handleReport={handleReport}

            surveyLanguageName={surveyLanguageName}
            handleLanguage={handleLanguage}
            LanguageList={LanguageList}

          />




          {/* Welcome Section */}
          {surveyStatus !== 2 && surveyStatus !== 3 ? (
            <>
              {showWelcomeScreen &&
                questionsList &&
                questionsList.length > 0 ? (
                <>
                  <div>
                    <section className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 md:py-10 py-4   flex   items-start h-[calc(100vh-5rem)]">
                      {/* right section 2 */}
                      <div className="md:flex hidden justify-center w-5/12 h-full  ">
                        <div className="bg-[#bbdefb] rounded-2xl flex justify-center items-center  w-full " style={{
                          backgroundImage: "url('https://plusinsight.happyplus.in/images//tp_assessment-welcome-large.webp')",
                          // getTheme("welcomeImage","/img/talent_assessment_intro.svg"),
                          backgroundSize: 'cover'
                        }}>

                          {themeType === 1 ?
                            <img
                              src={getTheme("welcomeImage", "/img/talent_assessment_intro.svg")}
                              className="2xl:w-10/12 w-11/12 mx-auto"
                            />
                            : null}

                        </div>
                      </div>

                      <div className="md:w-7/12 w-full 2xl:space-y-10  xl:space-y-8  space-y-8      ">
                        <div className="md:space-y-4 text-white text-base font-normal " style={{ color: getTheme("text", "#FFFFFF") }}>
                          <h1 className="left   font-medium xl:text-4xl text-2xl text-white/100  md:px-10 px-0 py-4  " style={{ color: getTheme("text", "#FFFFFF") }}>

                            {SurveyAttributes("Welcome_to_the_world_of_Infinite_possibilities") ? SurveyAttributes("Welcome_to_the_world_of_Infinite_possibilities") : "Welcome to the world of Infinite possibilities"}

                          </h1>

                          <div className="lg:h-[calc(100vh-25rem)] md:h-[calc(100vh-26rem)]  h-[calc(100vh-21rem)] overflow-y-auto custom-scroll space-y-4 md:px-10  pr-4 "
                            style={{ color: getTheme("text", "#FFFFFF") }}>


                            {(surveyLanguageCode !== '' && surveyLanguageCode !== 'en') ?
                              <div dangerouslySetInnerHTML={{
                                __html:
                                  functionNameVariable((surveyLanguageCode !== '') ?
                                    (surveyScreenData && surveyScreenData.transl && surveyScreenData.transl[surveyLanguageCode] && surveyScreenData.transl[surveyLanguageCode].welcomeText) ? surveyScreenData.transl[surveyLanguageCode].welcomeText : welcomeTextDislay
                                    : welcomeTextDislay)
                              }} />
                              :
                              <>
                                <p className="text-lg font-medium">Hello,</p>

                                <p className="text-md">
                                  We all are born with unique talents. Lot of us
                                  realise it at some point of time in our life.
                                  Luckier are those who get to know about it at
                                  the beginning of their life and use it to live
                                  a fulfilling and thriving life. But most of us
                                  are either unaware or realise our inherent
                                  talent quite late in our life, thus making our
                                  work & life boring.
                                </p>

                                <p className="text-lg font-medium">
                                  Now, no more.
                                </p>

                                <p className="text-md">
                                  <b className="font-semibold">
                                    {" "}
                                    TalentPlus assessment,{" "}
                                  </b>{" "}
                                  will allow you to know your inherent talents
                                  with a click of a button. Respond to our
                                  scientifically designed questionnaire and
                                  press the submit button. You will be able to
                                  download your talent themes immediately.
                                </p>

                                <p className="text-lg font-medium">Instructions:</p>

                                <ul className="list-decimal  list-inside  text-md ">
                                  <li>
                                    {" "}
                                    The test will take around{" "}
                                    <b className="font-semibold ">
                                      40 minutes
                                    </b>{" "}
                                    to finish.
                                  </li>
                                  <li>
                                    {" "}
                                    You get{" "}
                                    <b className="font-semibold ">
                                      20 seconds
                                    </b>{" "}
                                    to respond to each question.
                                  </li>
                                  <li>
                                    {" "}
                                    You should respond with your{" "}
                                    <b className="font-semibold ">
                                      first thought.
                                    </b>
                                  </li>
                                  <li>
                                    {" "}
                                    It’s a{" "}
                                    <b className="font-semibold ">
                                      10-point rating scale
                                    </b>
                                    , where{" "}
                                    <b className="font-semibold ">
                                      1 is Not like you
                                    </b>{" "}
                                    and{" "}
                                    <b className="font-semibold ">
                                      10 is Exactly like you.
                                    </b>
                                  </li>
                                  <li>
                                    {" "}
                                    There is no{" "}
                                    <b className="font-semibold ">
                                      right
                                    </b> or{" "}
                                    <b className="font-semibold ">wrong</b>{" "}
                                    answer. It’s just what you feel about a
                                    statement.{" "}
                                  </li>
                                </ul>

                                <p className=" text-md">
                                  Once done, press the submit button and click
                                  on your profile to see your result. Although
                                  the report is quite detailed and should give
                                  you a very deep insight on you and your
                                  talents still a coaching call with TalentPlus
                                  Consultant is recommended. You can fix up the
                                  same by writing to us at
                                  <b> contact@happyplus.in</b>
                                </p>

                                <p className="block text-md">All the best.</p>
                                <p className="text-lg font-medium">
                                  HappyPlus Assessment Team.
                                </p>

                              </>}










                          </div>
                        </div>

                        <div className=" w-full flex flex-col md:space-y-8 space-y-4  justify-start  md:pl-10 ">
                          <button
                            onClick={() => goToInstructionPage()}
                            className="md:w-80 w-full  uppercase md:text-xl text-base font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-4 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden"
                          >
                            <span className="absolute w-0 h-0 transition-all duration-300 ease-out bg-white rounded-full group-hover:w-[30rem] group-hover:h-[30rem] opacity-10"></span>
                            {SurveyAttributes("Start_Assessment")
                              ? SurveyAttributes("Start_Assessment")
                              : "START ASSESSMENT"}
                          </button>

                          <div className="flex md:justify-end justify-center mb-2">
                            <p className="  text-sm text-white/80 " style={{ color: getTheme("text", "#FFFFFF") }}>
                              © Powered by{" "}
                              <b class="font-medium text-white/100" style={{ color: getTheme("text", "#FFFFFF") }}>
                                HappyPlus
                              </b>
                            </p>
                          </div>
                        </div>
                      </div>

                    </section>
                  </div>
                </>
              ) : null}

              {/* Instruction Section */}

              {instructionPage ? (
                <>
                  <div>
                    <section
                      className="lg:w-5/6 md:py-6 py-4 mx-auto lg:px-0 md:px-6 px-2 "
                      style={{ height: "75%" }}
                    >
                      {/* logo */}
                      <div className="flex justify-center -mt-4"></div>

                      <p
                        style={{
                          color:
                            surveyScreenData && surveyScreenData.textColor
                              ? surveyScreenData.textColor
                              : "black",
                        }}
                        className="text-center py-2 font-bold text-2xl"
                      >
                        {LabelObj &&
                          LabelObj[surveyLanguageCode] &&
                          LabelObj[surveyLanguageCode].InstructionLabelText
                          ? LabelObj[surveyLanguageCode]
                            .InstructionLabelText
                          : SurveyAttributes("instructionLabel")
                            ? SurveyAttributes("instructionLabel")
                            : "Instructions"}
                      </p>

                      {/* pragraph */}
                      <div className="pb-24">
                        <div
                          id="chatbot"
                          className="cursor-default mx-4 mt-2 overflow-y-auto lg:px-14 lg:pl-32 lg:pr-4"
                          style={{
                            height: "400px",
                            color:
                              surveyScreenData && surveyScreenData.textColor
                                ? surveyScreenData.textColor
                                : "black",
                          }}
                          dangerouslySetInnerHTML={{
                            __html:
                              surveyLanguageCode !== ""
                                ? surveyScreenData &&
                                  surveyScreenData.transl &&
                                  surveyScreenData.transl[
                                  surveyLanguageCode
                                  ] &&
                                  surveyScreenData.transl[
                                    surveyLanguageCode
                                  ].instructionText
                                  ? surveyScreenData.transl[
                                    surveyLanguageCode
                                  ].instructionText
                                  : instructionTextDislay
                                : instructionTextDislay,
                          }}
                        />
                      </div>
                      <div className=" flex  justify-center ">
                        <div>
                          {/* btn */}
                          <button
                            onClick={() => goToQuestionPage()}
                            className="w-80  uppercase text-xl font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-4 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden"
                          // style={{

                          >
                            {SurveyAttributes("ContinueButtonText")
                              ? SurveyAttributes("ContinueButtonText")
                              : "Continue"}
                          </button>
                          <p
                            style={{
                              backgroundColor:
                                bgType === 1 || afterSubmitData.bgType === 1
                                  ? bgColor
                                    ? bgColor
                                    : afterSubmitData.bgColor
                                      ? afterSubmitData.bgColor
                                      : "#757575"
                                  : "#f1f1f1",
                              // backgroundImage:(bgType===2 || afterSubmitData.bgType===2)? (bgImage) ? bgImage : (afterSubmitData.bgImage)?afterSubmitData.bgImage: null   :null,
                            }}
                            className="text-sm py-4 pl-6"
                          >
                            {" "}
                            © Powered by{" "}
                            <b className="font-semibold">happyPlus</b>
                          </p>
                        </div>
                      </div>
                      {/*  */}
                    </section>
                  </div>
                </>
              ) : null}

              {/* Question Section */}

              {(showQuestionScreen && !submitSucces) ? (
                <div>
                  <div className="md:h-16 h-14 w-full bg-[#2196f3] flex items-center ">
                    <div className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 flex items-center justify-between ">
                      <div className="flex items-center md:space-x-2   text-white ">
                        <div className="flex items-center space-x-2   ">
                          <span className="material-symbols-outlined md:text-[2rem] text-[1rem]">
                            schedule
                          </span>
                          <p className="md:text-xl text-sm  ">
                            {SurveyAttributes("Remaining")
                              ? SurveyAttributes("Remaining")
                              : "Remaining"}</p>
                        </div>
                        <h1 className=" font-medium md:text-2xl text-sm p-2 ">
                          {getSecondsToTime(timeCounter)}
                        </h1>
                      </div>

                      <div className="flex items-center md:space-x-2 space-x-2 text-white ">
                        <span className="material-symbols-outlined md:text-[2rem] text-[1rem]">
                          check_circle
                        </span>
                        <p className="md:text-xl text-sm  ">{SurveyAttributes("Progress")
                          ? SurveyAttributes("Progress")
                          : "Progress"}</p>
                        <h1 className=" font-medium md:text-2xl text-sm  ">
                          {completedMilestone}
                          <b className="font-medium text-white/60 ">
                            {" "}
                            /{" "}
                            {questionsList && questionsList.length > 0
                              ? questionsList.length
                              : 0}
                          </b>
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className={"md:h-14 h-10 w-full flex items-center  " + (getTheme("grayheader", " bg-black/20 "))}>
                    <div className="2xl:w-8/12 xl:w-10/12 mx-auto xl:px-0 px-6 w-full flex items-center justify-center ">
                      <div className="flex items-center space-x-4 text-white ">
                        <span className="material-symbols-outlined md:text-[2rem] text-[1.5rem]" style={{ color: getTheme("text", "#FFFFFF") }}>
                          tips_and_updates
                        </span>
                        <p className="md:text-xl text-sm  " style={{ color: getTheme("text", "#FFFFFF") }}>
                          {SurveyAttributes("Kindly_answer_the_given_question")
                            ? SurveyAttributes("Kindly_answer_the_given_question")
                            : "Kindly answer the given question"}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Question survey design OLD */}
                  <section className="2xl:mt-24 xl:mt-24 lg:mt-12 md:mt-12 mt-4 2xl:w-[80%] xl:w-[90%] lg:w-[95%] w-full md:py-2 py-4 mx-auto lg:px-0 md:px-6 px-2 overflow-y-hidden overflow-x-hidden flex h-[calc(100vh-14rem)] ">
                    <div className="w-full" >
                      <TransitionGroup>
                        {questionsList && questionsList.length > 0
                          ? questionsList.map((question, questionindex) =>
                            questionindex + 1 === CurrQuesIndex ? (
                              // CurrQuesIndex
                              <CSSTransition
                                timeout={350}
                                classNames={changeType}
                                key={question.id}
                              >
                                <>
                                  <div>

                                    <section className="w-full mx-auto xl:px-0 px-4 md:py-10 py-4 flex items-start h-[calc(100vh-10rem)]">
                                      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                                        <div class="bg-white border rounded-lg p-6 relative">
                                          <h2 class="absolute -top-3 left-4 bg-white px-2 text-blue-600 text-xl font-medium">
                                            Question
                                          </h2>
                                          {question.templateId !== 14 ? (
                                            question.templateId === 10 ? (
                                              <>
                                                <p
                                                  style={{
                                                    color: getTheme("text", "#FFFFFF"),
                                                  }}
                                                  className=" mb-4 cursor-default quz md:text-2xl md:px-6 px-4 text-2xl text-white font-semibold md:py-6 py-4 md:mt-4  text-left italic"
                                                >
                                                  {/* {(questionindex+1).toString()+'. '} */}
                                                  <span className="font-bold">
                                                    {functionNameVariable(
                                                      surveyLanguageCode !== ""
                                                        ? question &&
                                                          question.transl &&
                                                          question.transl[
                                                          surveyLanguageCode
                                                          ] &&
                                                          question.transl[
                                                            surveyLanguageCode
                                                          ].name
                                                          ? question.transl[
                                                            surveyLanguageCode
                                                          ].name
                                                          : question.name
                                                        : question.name
                                                    )}
                                                  </span>

                                                  {question.isMandatory ? (
                                                    <div
                                                      style={{
                                                        background:
                                                          surveyScreenData &&
                                                            surveyScreenData.OptionColor1
                                                            ? surveyScreenData.OptionColor1
                                                            : "white",
                                                        color: getTheme("text", "#FFFFFF"),
                                                      }}
                                                      className="subtitle text-gray-500 font-semibold bg-gray-300 shadow-lg"
                                                    >
                                                      {SurveyAttributes(
                                                        "mandatoryText"
                                                      )
                                                        ? SurveyAttributes(
                                                          "mandatoryText"
                                                        )
                                                        : "This question is mandatory"}
                                                    </div>
                                                  ) : null}
                                                </p>
                                              </>
                                            ) : (
                                              <>
                                                {question.parentId ? (
                                                  <>
                                                    {question &&
                                                      question["QuesMain"] ? (
                                                      <>
                                                        <QuestionHeader
                                                          surveyLanguageCode={
                                                            surveyLanguageCode
                                                          }
                                                          question={
                                                            question["QuesMain"]
                                                          }
                                                        />
                                                      </>
                                                    ) : null}

                                                    <div
                                                      style={{
                                                        color: getTheme("text", "#FFFFFF"),
                                                      }}
                                                      className=" mb-2 cursor-default quz md:text-2xl md:px-6 px-4 text-lg text-white font-semibold md:py-4 py-2 md:mt-2  text-left"
                                                    >
                                                      {getGroupIndex(
                                                        question["QuesMain"].id
                                                      )}
                                                      {functionNameVariable(
                                                        surveyLanguageCode !==
                                                          ""
                                                          ? question &&
                                                            question[
                                                            "QuesMain"
                                                            ] &&
                                                            question["QuesMain"]
                                                              .transl &&
                                                            question["QuesMain"]
                                                              .transl[
                                                            surveyLanguageCode
                                                            ] &&
                                                            question["QuesMain"]
                                                              .transl[
                                                              surveyLanguageCode
                                                            ].name
                                                            ? question[
                                                              "QuesMain"
                                                            ].transl[
                                                              surveyLanguageCode
                                                            ].name
                                                            : question && [
                                                              "QuesMain",
                                                            ] &&
                                                              question[
                                                                "QuesMain"
                                                              ].name
                                                              ? question[
                                                                "QuesMain"
                                                              ].name
                                                              : ""
                                                          : question && [
                                                            "QuesMain",
                                                          ] &&
                                                            question["QuesMain"]
                                                              .name
                                                            ? question["QuesMain"]
                                                              .name
                                                            : ""
                                                      )}
                                                    </div>

                                                    <div
                                                      style={{
                                                        color: getTheme("text", "#FFFFFF"),
                                                      }}
                                                      className={
                                                        question.templateId ===
                                                          3 ||
                                                          question.templateId ===
                                                          4 ||
                                                          question.templateId ===
                                                          6 ||
                                                          question.templateId ===
                                                          16
                                                          ? "text-left mb-0 cursor-default quz md:text-2xl md:px-6 px-4 text-lg text-white font-normal  md:mt-2"
                                                          : " mb-2 cursor-default quz md:text-2xl md:px-6 px-4 text-lg text-white font-normal md:mt-2  text-left"
                                                      }
                                                    >
                                                      {question.isMandatory ? (
                                                        <div className="text-red-500 text-sm ">
                                                          {SurveyAttributes(
                                                            "mandatoryText"
                                                          )
                                                            ? SurveyAttributes(
                                                              "mandatoryText"
                                                            )
                                                            : "This question is mandatory*"}
                                                        </div>
                                                      ) : null}

                                                      {/* {(questionindex+1).toString()+'. '} */}
                                                      <span className="font-bold">
                                                        {" "}
                                                        {functionNameVariable(
                                                          surveyLanguageCode !==
                                                            ""
                                                            ? question &&
                                                              question.transl &&
                                                              question.transl[
                                                              surveyLanguageCode
                                                              ] &&
                                                              question.transl[
                                                                surveyLanguageCode
                                                              ].name
                                                              ? question.transl[
                                                                surveyLanguageCode
                                                              ].name
                                                              : question.name
                                                            : question.name
                                                        )}{" "}
                                                      </span>
                                                      {/* {<span style={{color:MandatoryMsg(question,questionindex + 1,CurrQuesIndex, this.state.unattemptList, this.state.showRedFlag).color}}>
                                    {MandatoryMsg(question,questionindex + 1,CurrQuesIndex,this.state.unattemptList, this.state.showRedFlag).text}
                                  </span>} */}
                                                      {/* {question.isMandatory?
                            <div style={{
                              background:(surveyScreenData && surveyScreenData.OptionColor1) ? surveyScreenData.OptionColor1:'white',
                              color:(surveyScreenData && surveyScreenData.OptionColor2) ? surveyScreenData.OptionColor2:'black',

                            }} className="subtitle text-gray-500 font-semibold bg-gray-300 shadow-lg">{SurveyAttributes("mandatoryText")?SurveyAttributes("mandatoryText"):"This question is mandatory"}</div>
                          :null} */}
                                                    </div>
                                                  </>
                                                ) : (
                                                  <>
                                                    <div className="quz">
                                                      <QuestionHeader
                                                        surveyLanguageCode={
                                                          surveyLanguageCode
                                                        }
                                                        questionName={functionNameVariable(
                                                          surveyLanguageCode !==
                                                            ""
                                                            ? question &&
                                                              question.transl &&
                                                              question.transl[
                                                              surveyLanguageCode
                                                              ] &&
                                                              question.transl[
                                                                surveyLanguageCode
                                                              ].name
                                                              ? question.transl[
                                                                surveyLanguageCode
                                                              ].name
                                                              : question.name
                                                            : question.name
                                                        )}
                                                        QuesNo={
                                                          (
                                                            questionindex + 1
                                                          ).toString() + ". "
                                                        }
                                                      />
                                                    </div>

                                                    <div

                                                      style={{
                                                        color: getTheme("text", "#FFFFFF"),
                                                      }}
                                                      className=" mb-2 cursor-default quz md:text-2xl md:px-6 px-4 text-lg text-white font-normal  md:mt-4  text-left"
                                                    >
                                                      {question.isMandatory ? (
                                                        <div className="text-red-500 text-sm ">
                                                          {SurveyAttributes(
                                                            "mandatoryText"
                                                          )
                                                            ? SurveyAttributes(
                                                              "mandatoryText"
                                                            )
                                                            : "This question is mandatory*"}
                                                        </div>
                                                      ) : null}

                                                      {(
                                                        questionindex + 1
                                                      ).toString() + ". "}
                                                      {functionNameVariable(
                                                        surveyLanguageCode !==
                                                          ""
                                                          ? question &&
                                                            question.transl &&
                                                            question.transl[
                                                            surveyLanguageCode
                                                            ] &&
                                                            question.transl[
                                                              surveyLanguageCode
                                                            ].name
                                                            ? question.transl[
                                                              surveyLanguageCode
                                                            ].name
                                                            : question.name
                                                          : question.name
                                                      )}
                                                    </div>
                                                  </>
                                                )}
                                              </>
                                            )
                                          ) : null}
                                        </div>

                                        <div class="bg-white border rounded-lg p-6 relative">
                                          <h2 class="absolute -top-3 left-4 bg-white px-2 text-orange-500 text-xl font-medium">
                                            Answer
                                          </h2>

                                          {/* NPS Scale 1-10*/}
                                          {question.templateId === 6 || question.templateId === 17 ? (
                                            <>
                                              <NPS
                                                question={question}
                                                answersList={answersList}
                                                surveyLanguageCode={
                                                  surveyLanguageCode
                                                }
                                                ansNPSInput={ansNPSInput}
                                                surveyScreenData={
                                                  surveyScreenData
                                                }
                                                isMobile={isMobile}
                                                questionsList={questionsList}
                                                CurrQuesIndex={CurrQuesIndex}
                                                nextQues={nextQues}
                                                SurveyAttributes={SurveyAttributes}
                                                getTheme={getTheme}
                                                arrLen={question.templateId === 17 ? 7 : 10}
                                              />
                                            </>
                                          ) : null}

                                          {/* NPS Scale 0-10*/}
                                          {question.templateId === 16 ? (
                                            <>


                                              <NPSV2
                                                question={question}
                                                answersList={answersList}
                                                surveyLanguageCode={
                                                  surveyLanguageCode
                                                }
                                                ansNPSInput={ansNPSInput}
                                                surveyScreenData={
                                                  surveyScreenData
                                                }
                                              />



                                            </>
                                          ) : null}



                                          {showFeedbackModal ? (
                                            <FeedbackModal
                                              closeModal={
                                                closeFeedbackModal
                                              }
                                              question={question}
                                              answersList={answersList}
                                              handleFeedbackInput={
                                                handleFeedbackInput
                                              }
                                              submitFeedback={
                                                submitFeedback
                                              }
                                              surveyScreenData={
                                                surveyScreenData
                                              }
                                              afterSubmitData={afterSubmitData}
                                            />
                                          ) : null}

                                        </div>

                                      </div>
                                    </section>

                                  </div>

                                  <div
                                    className={
                                      question.templateId === 13
                                        ? "px-4 -pt-4 justify-center items-center"
                                        : "px-4 pt-4 justify-center items-center"
                                    }
                                  >
                                    {unattemptList &&
                                      showRedFlag ? (
                                      unattemptList &&
                                        unattemptList.length >
                                        0 ? (
                                        <p className="md:px-6 px-4 md:text-md text-gray-100 font-light">
                                          <span
                                            style={{
                                              cursor: "default",
                                              color:
                                                surveyScreenData &&
                                                  surveyScreenData.textColor
                                                  ? surveyScreenData.textColor
                                                  : "black",
                                            }}
                                            className="font-semibold"
                                          >
                                            {
                                              "Please attempt mandatory question no. "
                                            }
                                          </span>
                                          {unattemptList.map(
                                            (elem, index) => (
                                              <span
                                                key={index}
                                                onClick={() =>
                                                  this.onMandatoryAttempt(
                                                    elem
                                                  )
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                  fontWeight: "bold",
                                                  color:
                                                    surveyScreenData &&
                                                      surveyScreenData.textColor
                                                      ? surveyScreenData.textColor
                                                      : "black",
                                                }}
                                              >
                                                {index + 1 ===
                                                  unattemptList
                                                    .length ? (
                                                  <span
                                                    style={{
                                                      textDecoration:
                                                        "underline",
                                                    }}
                                                  >
                                                    {" " + elem}
                                                  </span>
                                                ) : (
                                                  <span
                                                    style={{
                                                      textDecoration:
                                                        "underline",
                                                    }}
                                                  >
                                                    {elem + " , "}
                                                  </span>
                                                )}
                                              </span>
                                            )
                                          )}
                                        </p>
                                      ) : null
                                    ) : null}
                                  </div>

                                  {ShowSubmitButton ? (
                                    <>
                                      <div className="px-4 text-center text-red-500">
                                        {submitMandatory}
                                      </div>

                                      <div className="flex justify-center mt-6">
                                        <button
                                          onClick={() => !submitBlock ? saveAnswers(surveyScreenData) : {}}
                                          // onClick={() => this.saveAnswers()}
                                          className="md:w-80 w-60  uppercase md:text-xl text-base font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-4 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden "
                                        >
                                          {SurveyAttributes(
                                            "Submit"
                                          )
                                            ? SurveyAttributes(
                                              "Submit"
                                            )
                                            : "Submit"}
                                        </button>
                                      </div>





                                    </>
                                  ) : null}
                                </>
                              </CSSTransition>
                            ) : null
                          )
                          : null}
                      </TransitionGroup>

                      <div className="fixed bottom-0  left-0 w-full">
                        <div className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 md:py-6 py-4 md:bg-transparent bg-white/10">
                          <div className="w-full flex justify-end">
                            <div className="flex flex-col md:justify-center items-center 2xl:space-y-10 xl:space-y-10   space-y-4   w-full  ">
                              <div className="flex md:justify-end justify-center  w-full">
                                <p className="text-sm text-white/80 " style={{ color: getTheme("text", "#FFFFFF") }}>
                                  © Powered by
                                  <b className="ml-1 font-medium text-white/100" style={{ color: getTheme("text", "#FFFFFF") }}>
                                    HappyPlus
                                  </b>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                </div>
              ) : null}

              {showThankyouScreen ? (
                <>
                  <div className="h-[calc(100vh-8rem)] flex items-center justify-center">
                    <section className="2xl:w-8/12 xl:w-10/12 mx-auto xl:px-0 px-6 w-full py-10   flex md:space-x-10  items-start  ">
                      <div className=" lg:w-4/6 w-full mx-auto space-y-10 md:px-10   text-center">
                        <div className="space-y-4 text-white/80 text-base font-normal ">
                          <div className="flex flex-col justify-center items-center md:space-y-10 space-y-6">
                            <div className="md:w-[12rem] w-[10rem] md:h-[12rem] h-[10rem] rounded-full bg-white/10 flex justify-center items-center"
                              style={{ background: getTheme('lightblue', hexToRgbA('#FFFFFF', '0.10')) }}>
                              <div style={{ background: getTheme('textblue', hexToRgbA('#FFFFFF', '0.10')) }} className="md:w-[10rem] w-[8rem] h-[8rem] md:h-[10rem] rounded-full bg-white/20 flex justify-center items-center">
                                <span className="material-icons md:text-[4.5rem] text-[4rem] text-white">
                                  thumb_up
                                </span>
                              </div>
                            </div>
                            <h1 className="lg:text-5xl md:text-4xl text-3xl font-bold text-white" style={{ color: getTheme('text', '#FFFFFF') }}>
                              {EditButtonFn("ThankYou", "Thank You!")}
                            </h1>
                          </div>

                          <h1 className="  py-2 font-normal md:text-2xl text-xl text-white/100  " style={{ color: getTheme('text', '#FFFFFF') }}>
                            {EditButtonFn("ThankYouDesc", "For taking the assessment survey, your report will be generated soon. You can check your report after 5 minutes in the profile section.")}
                          </h1>
                        </div>

                        {/* {showViewReportThankYouButton ?
                          <div className=" w-full flex  justify-center ">
                            <button
                              onClick={() => handleReport(2)}
                              className="md:w-80 w-full  uppercase text-lg font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-4 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden  "
                            >
                              <span class="material-icons-outlined mr-2 text-[1.5rem]">
                                assignment
                              </span>
                              <span className="absolute w-0 h-0 transition-all duration-300 ease-out bg-white rounded-full group-hover:w-[30rem] group-hover:h-[30rem] opacity-10"></span>
                              {EditButtonFn("ViewReport", "View Report")}
                            </button>
                          </div>
                          :
                          <div className="px-6">
                            <div className="dot-pulse"></div>
                          </div>} */}


                        <div className="fixed bottom-0  left-0 w-full">
                          <div className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 md:py-6 py-4 md:bg-transparent bg-white/10">
                            <div className="w-full flex justify-end">
                              <div className="flex flex-col md:justify-center items-center 2xl:space-y-10 xl:space-y-10   space-y-4   w-full  ">
                                <div className="flex md:justify-end justify-center  w-full">
                                  <p className="text-sm text-white/80 " style={{ color: getTheme("text", "#FFFFFF") }}>
                                    © Powered by
                                    <b className="ml-1 font-medium text-white/100" style={{ color: getTheme("text", "#FFFFFF") }}>
                                      HappyPlus
                                    </b>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/*  */}
                    </section>
                  </div>
                </>
              ) : null}
            </>
          ) : null}




          {(surveyStatus === 2 &&
            !(questionsList && questionsList.length > 0)) ||
            alreadySubmitted ? ( //already done
            <div className="">
              <section className="xl:w-3/6 lg:w-4/6  py-6 mx-auto lg:px-0 md:px-6 px-6 ">
                <div className="flex justify-center pb-16 mt-12">

                </div>
                <div className="flex items-center h-full justify-center">
                  <div className="text-center text-white">
                    <div className="flex justify-center pb-8">
                      <img
                        alt="pic"
                        src="pictures/surveydone.png"
                        className="md:w-auto w-6/6 "
                      />
                    </div>
                    <h1
                      className="font-bold text-gray-800 md:text-4xl text-3xl tracking-widest leading_lose leading-10"
                      style={{}}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          color:
                            surveyScreenData && surveyScreenData.textColor
                              ? surveyScreenData.textColor
                              : "black",
                        }}
                        dangerouslySetInnerHTML={{
                          __html:

                            SurveyAttributes("AlreadyText")
                              ? "<h1>" +
                              SurveyAttributes("AlreadyText") +
                              "</h1>"
                              : "<h1>Survey Is Already Submitted !</h1>",
                        }}
                      />
                    </h1>
                    <p className="text-xl opacity-80 font-light py-2"></p>
                  </div>
                </div>
              </section>


              <div
                style={{
                  height: "10%",
                  backgroundColor:
                    bgType === 1 || afterSubmitData.bgType === 1
                      ? bgColor
                        ? bgColor
                        : afterSubmitData.bgColor
                          ? afterSubmitData.bgColor
                          : "#757575"
                      : "#f1f1f1",
                  backgroundImage:
                    bgType === 2 || afterSubmitData.bgType === 2
                      ? bgImage
                        ? bgImage
                        : afterSubmitData.bgImage
                          ? afterSubmitData.bgImage
                          : null
                      : null,
                }}
                className="fixed bottom-6  left-0 w-full flex  justify-center bg-white bg-opacity-100"
              >
                <p
                  className="text-sm py-4"
                  style={{ color: getTheme("text", "#FFFFFF") }}
                >
                  {" "}
                  © Powered by <b className="font-semibold">happyPlus</b>
                </p>
              </div>
            </div>
          ) : null}

          {/* survey expired page ----------------------------------------------------------------------------------------------- */}

          {surveyStatus === 3 &&
            !(questionsList && questionsList.length > 0) ? ( //expired
            <div>
              <section className="lg:w-4/6   mx-auto lg:px-0 md:px-6 px-2 flex items-center py-32 justify-center overflow-y-hidden">
                {/* logo */}
                <div>
                  <div className="flex justify-center">
                    <img src="img/expiry.png" className="w-32" />
                  </div>
                  <div className="flex items-center h-full justify-center">
                    <div
                      className="text-center font-bold text-2xl mt-6"
                      style={{
                        textAlign: "center",
                        color:
                          surveyScreenData && surveyScreenData.textColor
                            ? surveyScreenData.textColor
                            : "black",
                      }}
                      dangerouslySetInnerHTML={{
                        __html:

                          SurveyAttributes("ExpiryText")
                            ? "<h1>" +
                            SurveyAttributes("ExpiryText") +
                            "</h1>"
                            : "<h1>This Survey is <br>Expired!</h1>",
                      }}
                    />
                  </div>
                </div>
              </section>
              <div
                style={{
                  height: "10%",
                  backgroundColor:
                    bgType === 1 || afterSubmitData.bgType === 1
                      ? bgColor
                        ? bgColor
                        : afterSubmitData.bgColor
                          ? afterSubmitData.bgColor
                          : "#757575"
                      : "#f1f1f1",
                  backgroundImage:
                    bgType === 2 || afterSubmitData.bgType === 2
                      ? bgImage
                        ? bgImage
                        : afterSubmitData.bgImage
                          ? afterSubmitData.bgImage
                          : null
                      : null,
                }}
                className="fixed bottom-6  left-0 w-full flex  justify-center bg-white bg-opacity-100"
              >
                <p
                  className="text-sm py-4"
                  style={{ color: getTheme("text", "#FFFFFF") }}
                >
                  {" "}
                  © Powered by <b className="font-semibold">happyPlus</b>
                </p>
              </div>
            </div>
          ) : null}

        </div>


      </>
    );
  }
}
Survey.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  ////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users } = state;
  return {
    loggingIn,
    questions,
    users,
  };
}

export default connect(mapStateToProps)(Survey);
